// This file is auto-generated by vite-plugin-route-builder
// Do not edit manually
/* eslint-disable */
// @ts-nocheck

import type { RouteObject } from "react-router"

// Imports for page components
import * as SyncComponent0 from "./pages/(main)/index.sync"
const lazy0 = () => import("./pages/settings/layout")
const lazy1 = () => import("./pages/settings/index")
const lazy2 = () => import("./pages/settings/(settings)/about")
const lazy3 = () => import("./pages/settings/(settings)/ai")
const lazy4 = () => import("./pages/settings/(settings)/appearance")
const lazy5 = () => import("./pages/settings/(settings)/cli")
const lazy6 = () => import("./pages/settings/(settings)/data-control")
const lazy7 = () => import("./pages/settings/(settings)/feeds")
const lazy8 = () => import("./pages/settings/(settings)/general")
const lazy9 = () => import("./pages/settings/(settings)/integration")
const lazy10 = () => import("./pages/settings/(settings)/list")
const lazy11 = () => import("./pages/settings/(settings)/notifications")
const lazy12 = () => import("./pages/settings/(settings)/plan")
const lazy13 = () => import("./pages/settings/(settings)/profile")
const lazy14 = () => import("./pages/settings/(settings)/shortcuts")
const lazy15 = () => import("./pages/settings/(settings)/spotlight")
const lazy16 = () => import("./pages/(main)/layout")
const lazy17 = () => import("./pages/(main)/(layer)/timeline/[timelineId]/layout")
const lazy18 = () => import("./pages/(main)/(layer)/timeline/[timelineId]/[feedId]/layout")
const lazy19 = () => import("./pages/(main)/(layer)/timeline/[timelineId]/[feedId]/[entryId]/index")
const lazy20 = () => import("./pages/(main)/(layer)/timeline/[timelineId]/[feedId]/index")
const lazy21 = () => import("./pages/(main)/(layer)/(ai)/ai/index")
const lazy22 = () => import("./pages/(main)/(layer)/(subview)/layout")
const lazy23 = () => import("./pages/(main)/(layer)/(subview)/action/index")
const lazy24 = () => import("./pages/(main)/(layer)/(subview)/discover/category/[category]")
const lazy25 = () => import("./pages/(main)/(layer)/(subview)/discover/index")
const lazy26 = () => import("./pages/(main)/(layer)/(subview)/power/index")
const lazy27 = () => import("./pages/(main)/(layer)/(subview)/rsshub/index")

// Generated route configuration
export const routes: RouteObject[] = [
  {
    "path": "settings",
    "children": [
      {
        "path": "",
        "lazy": lazy0,
        "children": [
          {
            "path": "",
            "lazy": lazy1
          },
          {
            "path": "",
            "children": [
              {
                "path": "about",
                "lazy": lazy2
              },
              {
                "path": "ai",
                "lazy": lazy3
              },
              {
                "path": "appearance",
                "lazy": lazy4
              },
              {
                "path": "cli",
                "lazy": lazy5
              },
              {
                "path": "data-control",
                "lazy": lazy6
              },
              {
                "path": "feeds",
                "lazy": lazy7
              },
              {
                "path": "general",
                "lazy": lazy8
              },
              {
                "path": "integration",
                "lazy": lazy9
              },
              {
                "path": "list",
                "lazy": lazy10
              },
              {
                "path": "notifications",
                "lazy": lazy11
              },
              {
                "path": "plan",
                "lazy": lazy12
              },
              {
                "path": "profile",
                "lazy": lazy13
              },
              {
                "path": "shortcuts",
                "lazy": lazy14
              },
              {
                "path": "spotlight",
                "lazy": lazy15
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "path": "",
    "lazy": lazy16,
    "children": [
      {
        "path": "",
        "Component": SyncComponent0.Component,
        "loader": SyncComponent0.loader,
        "handle": SyncComponent0.handle
      },
      {
        "path": "",
        "children": [
          {
            "path": "timeline",
            "children": [
              {
                "path": ":timelineId",
                "children": [
                  {
                    "path": "",
                    "lazy": lazy17,
                    "children": [
                      {
                        "path": ":feedId",
                        "children": [
                          {
                            "path": "",
                            "lazy": lazy18,
                            "children": [
                              {
                                "path": ":entryId",
                                "children": [
                                  {
                                    "path": "",
                                    "lazy": lazy19
                                  }
                                ]
                              },
                              {
                                "path": "",
                                "lazy": lazy20
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "path": "",
            "children": [
              {
                "path": "ai",
                "children": [
                  {
                    "path": "",
                    "lazy": lazy21
                  }
                ]
              }
            ]
          },
          {
            "path": "",
            "lazy": lazy22,
            "children": [
              {
                "path": "action",
                "children": [
                  {
                    "path": "",
                    "lazy": lazy23
                  }
                ]
              },
              {
                "path": "discover",
                "children": [
                  {
                    "path": "category",
                    "children": [
                      {
                        "path": ":category",
                        "lazy": lazy24
                      }
                    ]
                  },
                  {
                    "path": "",
                    "lazy": lazy25
                  }
                ]
              },
              {
                "path": "power",
                "children": [
                  {
                    "path": "",
                    "lazy": lazy26
                  }
                ]
              },
              {
                "path": "rsshub",
                "children": [
                  {
                    "path": "",
                    "lazy": lazy27
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
]

export default routes
